module.exports = __webpack_public_path__ + "static/media/Intersection 17.c7b8d24d.png";